<script setup lang="ts">
import SubscriptionCard from './components/SubscriptionCard.vue'
import DashboardFornecedorService from './services/DashboardFornecedorService'
import type { ICurrentSubscription } from './types'

definePage({
  meta: {
    action: 'read',
    subject: 'auth',
  },
})

const loading = ref(false)
const subscriptionData = ref<ICurrentSubscription | null>(null)

const fetchSubscriptionData = async () => {
  loading.value = true
  try {
    const { data } = await DashboardFornecedorService.getCurrentSubscription()

    subscriptionData.value = data
  }
  catch (error) {
    console.error('Erro ao buscar assinatura:', error)
  }
  finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchSubscriptionData()
})
</script>

<template>
  <div class="dashboard-fornecedor-page">
    <!-- Subscription Card -->
    <VRow>
      <VCol cols="12">
        <SubscriptionCard
          :subscription="subscriptionData?.subscription || null"
          :loading="loading"
        />
      </VCol>
    </VRow>

    <!-- Quick Actions -->
    <VRow class="mt-6">
      <VCol
        cols="12"
        md="4"
      >
        <VCard class="action-card">
          <VCardText class="py-8 text-center">
            <VAvatar
              color="primary"
              variant="tonal"
              size="64"
              class="mb-4"
            >
              <VIcon
                icon="tabler-package"
                size="32"
              />
            </VAvatar>
            <h3 class="mb-2 text-h6 font-weight-bold">
              Meus Planos
            </h3>
            <p class="mb-4 text-sm text-medium-emphasis">
              Visualize e gerencie seus planos de assinatura
            </p>
            <VBtn
              color="primary"
              variant="tonal"
              block
              to="/admin/meu-plano"
            >
              Acessar
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>

      <VCol
        cols="12"
        md="4"
      >
        <VCard class="action-card">
          <VCardText class="py-8 text-center">
            <VAvatar
              color="success"
              variant="tonal"
              size="64"
              class="mb-4"
            >
              <VIcon
                icon="tabler-credit-card"
                size="32"
              />
            </VAvatar>
            <h3 class="mb-2 text-h6 font-weight-bold">
              Assinaturas
            </h3>
            <p class="mb-4 text-sm text-medium-emphasis">
              Gerencie suas assinaturas e histórico de pagamentos
            </p>
            <VBtn
              color="success"
              variant="tonal"
              block
              to="/admin/minhas-assinaturas"
            >
              Acessar
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>

      <VCol
        cols="12"
        md="4"
      >
        <VCard class="action-card">
          <VCardText class="py-8 text-center">
            <VAvatar
              color="info"
              variant="tonal"
              size="64"
              class="mb-4"
            >
              <VIcon
                icon="tabler-user-circle"
                size="32"
              />
            </VAvatar>
            <h3 class="mb-2 text-h6 font-weight-bold">
              Meu Perfil
            </h3>
            <p class="mb-4 text-sm text-medium-emphasis">
              Atualize suas informações e configurações
            </p>
            <VBtn
              color="info"
              variant="tonal"
              block
              to="/admin/fornecedor"
            >
              Acessar
            </VBtn>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>

<style scoped>
.dashboard-header {
  animation: fade-in 0.5s ease-out;
}

.action-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 8%);
  transition: all 0.3s ease;
}

.action-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 12%);
  transform: translateY(-4px);
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .dashboard-fornecedor-page {
    padding: 16px;
  }
}
</style>
